/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */
import { Component, Input, OnInit } from '@angular/core';
import FamilyMember from '../family-member.model';
import { FamilyMemberService } from '../family-member.service';

/**
 * Parent component container that houses all the child components and render logic for the family accounts feature.
 * This Component will also fetch all the necessary data for all the child components in order to correctly
 * render / display the HTML.
 */
@Component({
  templateUrl: './family-member-container.component.html',
  providers: [FamilyMemberService],
  standalone: false,
})
export class FamilyMemberContainerComponent implements OnInit {
  /*
        All initial data is fetched and obtained by this container, and is then passed down to the child-components.
        For instance, the parent / guardian, etc.
     */

  // Input that references the the parent / guardian.
  @Input() parent: any;

  public familyMembers: Array<FamilyMember> = [];

  public activities: Array<any> = [];

  constructor(public FamilyMemberService: FamilyMemberService) {
  }

  ngOnInit(): void {
    // Iterate over the family members and instantiate the family-members to be a family-member class, allowing
    // us to invoke specific methods:
    this.parent.family.studentIds.forEach((member) => {
      this.familyMembers.push(
        new FamilyMember(member.avatarURL, member.displayProps),
      );
    });

    this.FamilyMemberService.fetchStudentActivities(this.parent.id)
      .then((response) => {
        this.activities = response;
      });
  }
}
